import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function MechanismSection() {
  return <SectionWrapper data-id="element-59">
      <div className="text-center mb-12" data-id="element-60">
        <span className="text-amber font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-61">
          El Mecanismo Único
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary" data-id="element-62">
          El Método de Intervención No-Reactiva (INR)
        </h2>
      </div>

      <div className="prose prose-lg text-secondary font-body leading-relaxed mx-auto" data-id="element-63">
        <p data-id="element-64">
          La INR es una técnica de comunicación de alto impacto que corta el
          suministro de energía al conflicto. Al eliminar tu reacción emocional
          (el enojo, la súplica o la frustración), desarmas el mecanismo de
          defensa de tu hijo.
        </p>
        <p className="mt-6 font-medium text-primary italic text-xl border-l-2 border-amber pl-6 py-2" data-id="element-65">
          No es magia, es neurociencia aplicada: cuando tú dejas de ser una
          "amenaza", su puerta se abre por voluntad propia.
        </p>
      </div>
    </SectionWrapper>;
}